import React, {useEffect, useRef, useState} from "react";
import {NavLink} from 'react-router-dom'

import armaniExchangeSlider from '../assets/Male/armani-exchange.jpg';
import bossSlider from '../assets/Male/boss.jpg';
import guessSlider from '../assets/Male/guess.jpg';
import hugoSlider from '../assets/Male/hugo.jpg';
import mainSlider from '../assets/Male/male-banner.jpg';
import mangomanSlider from '../assets/Male/mangoman.jpg';

import banner1 from '../assets/Male/sec4.jpg';
import banner2 from '../assets/Male/sec1.jpg';
import banner3 from '../assets/Male/sec2.jpg';
import image1 from '../assets/slider/male/section5-image1.jpg';
import image2 from '../assets/slider/male/section5-image2.jpg';
import image3 from '../assets/slider/male/section5-image3.jpg';
import image4 from '../assets/slider/male/section5-image4.png';
//import video from '../assets/slider/male/male-video.mp4';
import video from '../assets/slider/male/video-male.webm';


import Productslider from "./Productslider";
import './Header.css';

import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Autoplay} from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import BrandFocusSlider from "./BrandFocusSlider";
import useBrands from "../hooks/useBrands";


const bannerListBase = [

    
    
    {
        image: mangomanSlider,
        path: '/brands/mangoman?gender=male',
        text: 'SHIKO KOLEKSIONIN',
        brand: 'mangoman'
    },
    {
        image: bossSlider,
        path: '/brands/boss?gender=male',
        text: 'SHIKO KOLEKSIONIN',
        brand: 'boss'
    },
    {
        image: guessSlider,
        path: '/brands/guess?gender=male',
        text: 'SHIKO KOLEKSIONIN',
        brand: 'guess'
    },
    {
        image: hugoSlider,
        path: '/brands/hugo?gender=male',
        brand: 'hugo',
        text: 'SHIKO KOLEKSIONIN'
    },
    {
        image: armaniExchangeSlider,
        path: '/brands/armani-exchange?gender=male',
        brand: 'armani-exchange',
        text: 'SHIKO KOLEKSIONIN'
    }
]
export default function Male() {
    const {brands} = useBrands()
    const vidRef = useRef();
    const [bannerList, setBannerList] = useState(bannerListBase)

    useEffect(() => {
        setBannerList(prevState => prevState.map((item)=>{
            const brandImage = brands.find(b => b.slug === item.brand)?.brandImage;
            return {...item, brandImage}
        }))
        // vidRef.current.play();
    }, [brands]);


    return (

        <div className="bg-gradient-to-b from-neutral-50 to-white">

            <div className="cover-section relative z-0">
                <Swiper
                    slidesPerView={1}
                    spaceBetween={0}
                    loop={true}
                    centeredSlides={true}
                    autoplay={{
                        delay: 15000,
                        disableOnInteraction: false,
                    }}
                    pagination={false}
                    navigation={false}
                    modules={[Autoplay]}
                    className="mySwiper"
                >
                    {bannerList.map((item, index) => {
                        return (
                            <SwiperSlide key={index}>
                                {({isActive})=>(<>
                                    <NavLink
                                        to={item.path}
                                        aria-label={item.text || 'Shiko koleksionin'}
                                        className="block relative albi-grain cursor-pointer"
                                    >
                                        {item.brandImage && (
                                            <img
                                                style={
                                                    item.brand === 'armani-exchange' || item.brand === 'guess'
                                                        ? { filter: 'invert(0)' }
                                                        : {}
                                                }
                                                src={item.brandImage}
                                                className={'male-slider-brand slider-brandImage animate__animated' + (isActive ? 'animate__slideInRight' : '')}
                                                alt={item.brand}
                                                width="100%"
                                            />
                                        )}
                                        <img
                                            className={'slider-image max-h-[380px] sm:max-h-[500px] lg:max-h-[560px] object-cover'}
                                            src={item.image}
                                            alt={item.brand}
                                            width="100%"
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-black/5 to-transparent pointer-events-none" />
                                    </NavLink>
                                </>)}
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>

            {/* Quick links: mbi fundin e banerit (overlap i thellë); z-2 mbi hero, cart-section z-3 më poshtë */}
            <div className="relative z-[2] -mt-16 sm:-mt-20 lg:-mt-24">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        <NavLink
                            to="/search/male"
                            className="group relative overflow-hidden rounded-2xl bg-white shadow-[0_22px_60px_-40px_rgba(0,0,0,0.65)] ring-1 ring-black/5 hover:ring-black/10 transition"
                        >
                            <div className="absolute inset-0 bg-gradient-to-tr from-black/55 via-black/20 to-transparent z-[1] pointer-events-none group-hover:from-black/60 transition-colors duration-500" />
                            <div
                                className="relative z-0 h-[140px] sm:h-[132px] lg:h-[140px] bg-cover bg-center"
                                style={{ backgroundImage: `url(${mainSlider})` }}
                            />
                            <div className="absolute inset-0 z-[2] p-5 pb-6 flex items-end justify-between">
                                <div className="text-white">
                                    <div className="text-[11px] font-semibold tracking-[0.26em] uppercase text-white/80">All Products</div>
                                    <div className="mt-1 text-lg font-semibold">Të gjitha</div>
                                </div>
                                <div className="text-white/90 text-sm font-semibold">→</div>
                            </div>
                        </NavLink>

                        <NavLink
                            to="/new-arrivals?gender=male"
                            className="group relative overflow-hidden rounded-2xl bg-white shadow-[0_22px_60px_-40px_rgba(0,0,0,0.65)] ring-1 ring-black/5 hover:ring-black/10 transition"
                        >
                            <div className="absolute inset-0 bg-gradient-to-tr from-black/55 via-black/20 to-transparent z-[1] pointer-events-none group-hover:from-black/60 transition-colors duration-500" />
                            <div
                                className="relative z-0 h-[140px] sm:h-[132px] lg:h-[140px] bg-cover bg-center"
                                style={{ backgroundImage: `url(${guessSlider})` }}
                            />
                            <div className="absolute inset-0 z-[2] p-5 pb-6 flex items-end">
                                <div className="text-white">
                                    <div className="text-[11px] font-semibold tracking-[0.26em] uppercase text-white/80">New in</div>
                                    <div className="mt-1 text-lg font-semibold">Më të rejat</div>
                                </div>
                            </div>
                        </NavLink>

                        <NavLink
                            to="/top-picks?gender=male"
                            className="group relative overflow-hidden rounded-2xl bg-white shadow-[0_22px_60px_-40px_rgba(0,0,0,0.65)] ring-1 ring-black/5 hover:ring-black/10 transition"
                        >
                            <div className="absolute inset-0 bg-gradient-to-tr from-black/55 via-black/20 to-transparent z-[1] pointer-events-none group-hover:from-black/60 transition-colors duration-500" />
                            <div
                                className="relative z-0 h-[140px] sm:h-[132px] lg:h-[140px] bg-cover bg-center"
                                style={{ backgroundImage: `url(${hugoSlider})` }}
                            />
                            <div className="absolute inset-0 z-[2] p-5 pb-6 flex items-end">
                                <div className="text-white">
                                    <div className="text-[11px] font-semibold tracking-[0.26em] uppercase text-white/80">Top Picks</div>
                                    <div className="mt-1 text-lg font-semibold">Top Zgjedhjet</div>
                                </div>
                            </div>
                        </NavLink>

                        <NavLink
                            to="/brands"
                            className="group relative overflow-hidden rounded-2xl bg-white shadow-[0_22px_60px_-40px_rgba(0,0,0,0.65)] ring-1 ring-black/5 hover:ring-black/10 transition"
                        >
                            <div className="absolute inset-0 bg-gradient-to-tr from-black/55 via-black/20 to-transparent z-[1] pointer-events-none group-hover:from-black/60 transition-colors duration-500" />
                            <div
                                className="relative z-0 h-[140px] sm:h-[132px] lg:h-[140px] bg-cover bg-center"
                                style={{ backgroundImage: `url(${bossSlider})` }}
                            />
                            <div className="absolute inset-0 z-[2] p-5 pb-6 flex items-end justify-between">
                                <div className="text-white">
                                    <div className="text-[11px] font-semibold tracking-[0.26em] uppercase text-white/80">Brands</div>
                                    <div className="mt-1 text-lg font-semibold">Brendet</div>
                                </div>
                                <div className="text-white/90 text-sm font-semibold">→</div>
                            </div>
                        </NavLink>
                    </div>
                </div>
            </div>


            <div className="cart-section relative z-[3] mt-10 sm:mt-20">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div className="flex items-end justify-between gap-6 py-4">
                        <div>
                            <div className="text-[11px] font-semibold tracking-[0.22em] text-neutral-500 uppercase">
                                NEW COLLECTION
                            </div>
                            <div className="title_block !mt-1">
                                Më të rejat
                            </div>
                        </div>
                        <NavLink
                            to="/new-arrivals?gender=male"
                            className="inline-flex items-center gap-2 rounded-full border border-neutral-200 bg-white px-4 py-2 text-xs font-semibold tracking-wide text-neutral-800 shadow-sm hover:border-neutral-300 hover:bg-neutral-50 transition-colors"
                        >
                            Shiko më shumë
                            <span aria-hidden="true">→</span>
                        </NavLink>
                    </div>
                </div>
                <Productslider start='1' limit='20' type='newin' dataSource='new-arrivals' gender='male' eager prefetchPx={2000}/>
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mt-9">
                    <div className="flex items-end justify-between gap-6 py-4">
                        <div>
                            <div className="text-[11px] font-semibold tracking-[0.22em] text-neutral-500 uppercase">
                                TOP PICKS
                            </div>
                            <div className="title_block !mt-1">
                                Top Zgjedhjet
                            </div>
                        </div>
                        <NavLink
                            to="/top-picks?gender=male"
                            className="inline-flex items-center gap-2 rounded-full border border-neutral-200 bg-white px-4 py-2 text-xs font-semibold tracking-wide text-neutral-800 shadow-sm hover:border-neutral-300 hover:bg-neutral-50 transition-colors"
                        >
                            Shiko më shumë
                            <span aria-hidden="true">→</span>
                        </NavLink>
                    </div>
                </div>
                <Productslider start='1' limit='20' type='toppicks' dataSource='top-picks' gender='male' eager prefetchPx={2000}/>
            </div>

            <div className='section-5 video-sec'>
                <div id="shopify-section-16141564777b64a0a2"
                     className="shopify-section index-section section-video wow fadeInUp  animated">

                    <div data-section-id="16141564777b64a0a2">
                        <div className="distance">
                            <div className="container-1320">
                                <div className="block">
                                    <div className="item youtube position-relative rounded-2xl overflow-hidden shadow-sm ring-1 ring-black/5">

                                        <video src={video} muted autoPlay loop width='100%' height='100%'
                                               webkit-playsinline="true" playsInline/>

                                        {/* <div className="block_title text-center">

                      <div className="sub-title-1 text-uppercase">NEW ARRIVALS</div>
                      <div className="title_block">ËSHTË MOMENTI YT</div>
                      <div className="sub-title-2">Trendet e fundit i gjeni vetëm në Albi Online</div>
                      <div className="sub-title-4 text-uppercase"></div>
                    </div> */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mt-10">
                <div className="text-[11px] font-semibold tracking-[0.22em] text-neutral-500 uppercase">
                    Brendet
                </div>
                <div className="title_block !mt-1">
                    Në Fokus
                </div>
            </div>
            <div className="pb-6">
                <BrandFocusSlider gender='male' />
            </div>
        </div>
    )
}